module.exports = "<p>\n  logout-page works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/logout-page/logout-page.component.html
// module id = ../../../../../src/app/pages/logout-page/logout-page.component.html
// module chunks = main